const fasArrowAltCircle = {
	Left: ['fas', 'arrow-alt-circle-left'],
	Right: ['fas', 'arrow-alt-circle-right'],
	Up: ['fas', 'arrow-alt-circle-up'],
	Down: ['fas', 'arrow-alt-circle-down']
};
const farArrowAltCircle = {
	Left: ['far', 'arrow-alt-circle-left'],
	Right: ['far', 'arrow-alt-circle-right'],
	Up: ['far', 'arrow-alt-circle-up'],
	Down: ['far', 'arrow-alt-circle-down']
};

const fasCaretSquare = {
	Left: ['fas', 'caret-square-left'],
	Right: ['fas', 'caret-square-right'],
	Up: ['fas', 'caret-square-up'],
	Down: ['fas', 'caret-square-down']
};

const farCaretSquare = {
	Left: ['far', 'caret-square-left'],
	Right: ['far', 'caret-square-right'],
	Up: ['far', 'caret-square-up'],
	Down: ['far', 'caret-square-down']
};

const fasArrow = {
	Left: ['fas', 'arrow-left'],
	Right: ['fas', 'arrow-right'],
	Up: ['fas', 'arrow-up'],
	Down: ['fas', 'arrow-down']
};

const fasAngle = {
	Left: ['fas', 'angle-left'],
	Right: ['fas', 'angle-right'],
	Up: ['fas', 'angle-up'],
	Down: ['fas', 'angle-down']
};

const fasAngleDouble = {
	Left: ['fas', 'angle-double-left'],
	Right: ['fas', 'angle-double-right'],
	Up: ['fas', 'angle-double-up'],
	Down: ['fas', 'angle-double-down']
};

const defaultArrow = {
	Left: 'ľ',
	Right: 'ř',
	Up: 'ů',
	Down: 'ď'
};

export default {
	Left: 'ľ',
	Right: 'ř',
	Up: 'ů',
	Down: 'ď',
	// eslint-disable-next-line complexity
	get (name, type) {
		let arrowSet;

		if (!type || type === 'default') {
			arrowSet = defaultArrow;
		} else if (type === 'fas-arrow-alt-circle') {
			arrowSet = fasArrowAltCircle;
		} else if (type === 'far-arrow-alt-circle') {
			arrowSet = farArrowAltCircle;
		} else if (type === 'fas-caret-square') {
			arrowSet = fasCaretSquare;
		} else if (type === 'far-caret-square') {
			arrowSet = farCaretSquare;
		} else if (type === 'fas-arrow') {
			arrowSet = fasArrow;
		} else if (type === 'fas-angle') {
			arrowSet = fasAngle;
		} else if (type === 'fas-angle-double') {
			arrowSet = fasAngleDouble;
		}

		return getArrow(arrowSet, name, type);
	}
};

function getArrow (arrowSet, name, type) {
	if (!arrowSet) {
		return null;
	}

	switch (name) {
	case 'l': return {type, value: arrowSet.Left};
	case 'r': return {type, value: arrowSet.Right};
	case 'u': return {type, value: arrowSet.Up};
	case 'd': return {type, value: arrowSet.Down};
	default: return null;
	}
}
